// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__dJxab","inner":"Footer_inner__10KRQ"};